module.exports = __webpack_public_path__ + "static/media/submarineRealBig.879f5828.png";